module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_42.dot-f4baaa29d25067504a8d1d89c8d7bda2.svg";